export const DEMO_SCRIPT = {
  fa: [
    { from: "bot", text: "سلام! 👋 من دستیار هوشمند رایابات هستم. چطور می‌تونم امروز کمکتون کنم؟" },
    { from: "me",  text: "سلام، می‌خواستم قیمت پلن حرفه‌ای رو بدونم" },
    { from: "bot", text: "پلن حرفه‌ای ماهانه ۹۹۰ هزار تومانه و شامل تمام امکانات AI، اتصال نامحدود و پشتیبانی VIP هست. ✨" },
    { from: "me",  text: "سفارشم کی می‌رسه؟ 🚚" },
    { from: "bot", text: "سفارش شما امروز ساعت ۱۴ ارسال می‌شه و فردا تحویل داده می‌شه. 📦" },
    { from: "me",  text: "ممنون! امکان تغییر آدرس هست؟" },
    { from: "bot", text: "بله، تا ۲ ساعت قبل از ارسال می‌تونید از پنل کاربری آدرس رو تغییر بدید. ✅" },
  ],
  en: [
    { from: "bot", text: "Hi! 👋 I'm Rayabot's smart assistant. How can I help you today?" },
    { from: "me",  text: "Hi, I'd like to know the Pro plan price" },
    { from: "bot", text: "The Pro plan is 990K Toman/month with full AI features, unlimited integrations, and VIP support. ✨" },
    { from: "me",  text: "When will my order arrive? 🚚" },
    { from: "bot", text: "Your order ships today at 2 PM and will be delivered tomorrow. 📦" },
    { from: "me",  text: "Thanks! Can I change the address?" },
    { from: "bot", text: "Yes, you can update it from your dashboard up to 2 hours before shipping. ✅" },
  ],
  ar: [
    { from: "bot", text: "مرحباً! 👋 أنا مساعد رايابوت الذكي. كيف يمكنني مساعدتك اليوم؟" },
    { from: "me",  text: "مرحباً، أريد معرفة سعر الخطة الاحترافية" },
    { from: "bot", text: "الخطة الاحترافية ٩٩٠ ألف تومان شهرياً وتشمل كل ميزات الذكاء الاصطناعي والتكامل غير المحدود ودعم VIP. ✨" },
    { from: "me",  text: "متى سيصل طلبي؟ 🚚" },
    { from: "bot", text: "سيُشحن طلبك اليوم الساعة ٢ ظهراً وسيُسلَّم غداً. 📦" },
    { from: "me",  text: "شكراً! هل يمكنني تغيير العنوان؟" },
    { from: "bot", text: "نعم، يمكنك تحديثه من لوحة التحكم حتى ساعتين قبل الشحن. ✅" },
  ],
};